const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/supervisor/team/cameras.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/supervisor/team/cameras.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { SupervisorCamerasPendingState } from '@/features/supervisor/components/SupervisorCamerasPendingState';
import { SupervisorCamerasRail } from '@/features/supervisor/components/SupervisorCamerasRail';
import { supervisorCamerasSearchSchema } from '@/features/supervisor/lib/search';
import { toSupervisorCamerasFilters } from '@/features/supervisor/lib/teamSearch';
import { supervisorCamerasQuery } from '@/features/supervisor/services/supervisorQueries';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_app/supervisor/team/cameras')({
  beforeLoad: requireCapabilities(has => has('devices.read')),
  validateSearch: supervisorCamerasSearchSchema,
  loaderDeps: ({
    search
  }) => ({
    filters: toSupervisorCamerasFilters(search)
  }),
  loader: ({
    context,
    deps
  }) => context.queryClient.ensureInfiniteQueryData(supervisorCamerasQuery(deps.filters)),
  staticData: {
    sectionShell: {
      secondarySidebar: SupervisorCamerasRail
    }
  },
  pendingComponent: SupervisorCamerasPendingState,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});